module.exports = __webpack_public_path__ + "img/szjc11.f3c65859.png";